import { useParams, useNavigate } from 'react-router-dom';
import MeditationPlayer from '@/components/meditation/meditation-player';
import { useToast } from '@/components/ui/use-toast';
import Loading from '@/components/loading';
import { useContentWithConfig, useContentList } from '@/lib/hooks/use-content';
import { ROUTES } from '@/lib/constants';
import { useProfile } from '@/lib/providers';
import { AdminRole, ContentType } from '@/types/custom';

/**
 * Render a single meditation for playing.
 * Let's you select and then play the desired configuration.
 */
export default function MeditationPage() {
  const { profile, loadingProfile } = useProfile();
  const isAdmin = profile?.role === AdminRole;
  const { id } = useParams();
  const navigate = useNavigate();
  const { toast } = useToast();

  // load meditation data
  const { contentWithConfig: contentData, loading: loadingContent } =
    useContentWithConfig(id);

  const contentType = (contentData?.content.content_type as ContentType) || 'meditation';
  const { contentWithConfigs: siblings } = useContentList(contentType, [contentType]);

  const handleNext = () => {
    const published = siblings.filter((s) => s.content.published || isAdmin);
    const currentIndex = published.findIndex((s) => s.content.id === id);
    if (published.length > 1) {
      const nextIndex = (currentIndex + 1) % published.length;
      navigate(`${ROUTES.MEDITATIONS}/${published[nextIndex].content.id}`);
    }
  };

  if (loadingProfile || loadingContent) {
    return <Loading />;
  }

  if (!loadingContent && !contentData) {
    toast({
      title: 'Niet gevonden',
      description: `ID ${id}`,
    });
    navigate(ROUTES.NOT_FOUND, { replace: true });
    return;
  }

  return <MeditationPlayer contentData={contentData} onNext={handleNext} />;
}
